import { Schema } from "@comparaonline/products-schema";
import get from "lodash.get";

import { ProviderData } from "../../../lib/appContext/types";
import { ICta } from "./types";

const getExternalRedirect = (businessUnitConfig: any) =>
  get(businessUnitConfig, "widgets.hero.config.primaryButton.href");

export const getCaptureUrl = (
  businessUnitSlug: string,
  { slug: productSlug, division: { slug: divisionSlug } }: Schema.ProductListProduct
): string => `/${businessUnitSlug}/form/capture/${divisionSlug}/${productSlug}`;

export const getCaptureCta = (
  { businessUnitConfig, businessUnitSlug }: ProviderData,
  product: Schema.ProductListProduct
): ICta => ({
  disabled: !product.enabled || !product.active,
  text: businessUnitConfig.resultCTA,
  url: getExternalRedirect(businessUnitConfig) || getCaptureUrl(businessUnitSlug, product)
});
